import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError, API } from "@/lib/api";
import { toast } from "sonner";
import { Download, Trash2, Power, Send } from "lucide-react";

function formatDate(iso) { try { return new Date(iso).toLocaleString("de-DE"); } catch { return ""; } }

export default function AdminNewsletter() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  async function load() { setLoading(true); try { const { data } = await api.get("/newsletter"); setItems(data || []); } finally { setLoading(false); } }
  useEffect(() => { load(); }, []);

  async function toggle(id) {
    try { await api.put(`/newsletter/${id}/toggle`); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  }
  async function del(id) {
    if (!window.confirm("Eintrag löschen?")) return;
    try { await api.delete(`/newsletter/${id}`); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  }
  async function exportCsv() {
    const token = localStorage.getItem("admin_token");
    const res = await fetch(`${API}/newsletter/export.csv`, { credentials: "include", headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (!res.ok) { toast.error("Export fehlgeschlagen"); return; }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div data-testid="admin-newsletter">
      <div className="flex items-center justify-between mb-10">
        <div>
          <h1 className="font-semibold text-3xl mb-1">Newsletter</h1>
          <p className="text-sm text-neutral-500">Bestätigte Abonnenten verwalten und Nachrichten verschicken.</p>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/admin/newsletter/versenden" data-testid="newsletter-open-composer" className="inline-flex items-center gap-2 bg-[hsl(var(--brand-green-strong))] text-white px-4 py-2.5 text-sm hover:opacity-90">
            <Send className="h-4 w-4" /> Newsletter versenden
          </Link>
          <button onClick={exportCsv} data-testid="newsletter-export" className="inline-flex items-center gap-2 border border-brand-line px-4 py-2.5 text-sm hover:bg-neutral-50">
            <Download className="h-4 w-4" /> CSV exportieren
          </button>
        </div>
      </div>

      <div className="bg-white border border-brand-line">
        {loading ? <p className="p-8 text-sm text-neutral-500">Lade…</p> :
        items.length === 0 ? <p className="p-8 text-sm text-neutral-500">Noch keine Anmeldungen.</p> : (
          <table className="w-full text-sm">
            <thead className="bg-neutral-50 text-xs uppercase tracking-wider text-neutral-500">
              <tr>
                <th className="text-left px-5 py-3 font-normal">E-Mail</th>
                <th className="text-left px-5 py-3 font-normal">Status</th>
                <th className="text-left px-5 py-3 font-normal">Angemeldet am</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items.map((n) => (
                <tr key={n.id} className="border-t border-brand-line" data-testid={`newsletter-row-${n.id}`}>
                  <td className="px-5 py-4">{n.email}</td>
                  <td className="px-5 py-4">
                    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-xs ${n.active ? "bg-[hsl(var(--brand-soft))] text-[hsl(var(--brand-green-strong))]" : "bg-neutral-100 text-neutral-500"}`}>
                      <span className={`h-1.5 w-1.5 rounded-full ${n.active ? "bg-[hsl(var(--brand-green-strong))]" : "bg-neutral-400"}`} />
                      {n.active ? "Aktiv" : "Inaktiv"}
                    </span>
                  </td>
                  <td className="px-5 py-4 text-neutral-600">{formatDate(n.created_at)}</td>
                  <td className="px-5 py-4 text-right">
                    <div className="inline-flex items-center gap-3">
                      <button onClick={() => toggle(n.id)} className="text-neutral-500 hover:text-[hsl(var(--brand-green-strong))]" title="Aktiv/Inaktiv"><Power className="h-4 w-4" /></button>
                      <button onClick={() => del(n.id)} className="text-neutral-500 hover:text-red-600" title="Löschen"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <p className="mt-6 text-xs text-neutral-400">
        Hinweis: Der direkte Mailversand ist derzeit nicht aktiviert. Die Liste kann jederzeit exportiert oder später an einen externen Newsletter-Dienst angebunden werden.
      </p>
    </div>
  );
}
